module.exports = __webpack_public_path__ + "img/floor_f7_01.c985c90f.png";